import {
  emptyValidator,
  formValidator,
  mobilePhoneMenValidator,
  mobilePhoneNotMenValidator,
  nicValidator,
} from "../../validators";

const agreementValidationStatus = {
//   agrName: {
//     validators: [emptyValidator()],
//     name: "Agreement Name",
//   },
  agrCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  agrFromDate: {
    validators: [emptyValidator()],
    name: "Agreement From Date",
  },
  agrToDate: {
    validators: [emptyValidator()],
    name: "Agreement To Date",
  },
  agrStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  agrActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  agrOwnerName: {
    validators: [emptyValidator()],
    name: "Owner Name",
  },
  agrOwnerNic: {
    validators: [emptyValidator(), nicValidator()],
    name: "Owner NIC",
  },
  agrOwnerContactNo: {
    validators: [emptyValidator(),mobilePhoneMenValidator()],
    name: "Owner Contact Number",
  },
  agrReference: {
    validators: [emptyValidator()],
    name: "Reference",
  },
};

export const agreementValidation = (agreementData) => {
  return formValidator(agreementData, agreementValidationStatus);
};
